// extracted by mini-css-extract-plugin
module.exports = {"date":"ReviewCard_date__ptLhI","item":"ReviewCard_item__nvwYi","meta":"ReviewCard_meta__UrIco","title":"ReviewCard_title__qyVUs","customer":"ReviewCard_customer__pOvLH"};